module.exports = __webpack_public_path__ + "static/media/sf-trial-1-wrong.50f91fae.mp3";